const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);

              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  }
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function() {
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function() {
    checkSwatches();
  });
}


/* =============================================================
   CARD SIZE VARIANT PICKER
   Uses the Shopify Section Rendering API so the cart drawer
   re-renders with the new item exactly the same way the
   theme's own product forms do.
   ============================================================= */

const addVariantToCart = (variantId, triggerBtn) => {
  // Loading state on the size button
  triggerBtn.classList.add('card__size-btn--loading');
  triggerBtn.setAttribute('aria-disabled', 'true');

  // The sections the cart drawer needs re-rendered after add.
  // These match CartDrawer.getSectionsToRender() in the theme JS.
  const sections = ['cart-drawer', 'cart-icon-bubble'];

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: parseInt(variantId),
      quantity: 1,
      sections: sections,
      sections_url: window.location.pathname
    })
  })
  .then(function(response) {
    if (!response.ok) {
      return response.json().then(function(err) { throw err; });
    }
    return response.json();
  })
  .then(function(data) {
    // Reset button state
    triggerBtn.classList.remove('card__size-btn--loading');
    triggerBtn.removeAttribute('aria-disabled');

    // Hand the response off to the theme's CartDrawer.renderContents()
    // which knows how to update the drawer DOM with the new sections HTML
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
      cartDrawerEl.renderContents(data);
    } else {
      // Fallback: fire events and try clicking the cart icon
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var cartToggle = document.querySelector('#cart-icon-bubble');
      if (cartToggle) cartToggle.click();
    }

    // Brief tick confirmation on the size button
    var originalText = triggerBtn.textContent.trim();
    triggerBtn.textContent = '✓';
    setTimeout(function() {
      triggerBtn.textContent = originalText;
      triggerBtn.classList.remove('card__size-btn--active');
    }, 1500);
  })
  .catch(function(error) {
    console.error('Add to cart failed:', error);
    triggerBtn.classList.remove('card__size-btn--loading');
    triggerBtn.removeAttribute('aria-disabled');
  });
};


const initCardVariantPickers = () => {
  document.querySelectorAll('.card__size-picker').forEach(function(picker) {
    picker.querySelectorAll('.card__size-btn').forEach(function(btn) {

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (btn.getAttribute('aria-disabled') === 'true') return;

        var variantId = btn.dataset.variantId;

        // Highlight selected size immediately
        picker.querySelectorAll('.card__size-btn').forEach(function(b) {
          b.classList.remove('card__size-btn--active');
        });
        btn.classList.add('card__size-btn--active');

        if (!variantId || variantId === '') {
          // Safety fallback: look up variant via product JSON
          var productHandle = picker.dataset.productHandle;
          var selectedValue = btn.dataset.value;

          jQuery.getJSON(window.Shopify.routes.root + 'products/' + productHandle + '.js', function(product) {
            var matched = product.variants.find(function(v) {
              return v.available && v.options.includes(selectedValue);
            });
            if (matched) {
              addVariantToCart(matched.id, btn);
            }
          });
          return;
        }

        addVariantToCart(variantId, btn);
      });
    });
  });
};


function cardVariantPickers() {
  initCardVariantPickers();

  document.addEventListener('shopify:section:load', function() {
    initCardVariantPickers();
  });
}


(function() {
  colorSwatches();
  cardVariantPickers();
})();